import { SectionSummaryContent, SectionSummaryContentItem } from '@/shared/components/SectionSummary.tsx';
import { useTranslation } from 'react-i18next';
import { useFormatters } from '@/shared/hooks/useFormatters/useFormatters.ts';
import { usePositionContext } from '@/shared/context/PositionContext.tsx';
import { SUPPORTED_UNIT_LABEL } from '@/phrase/SupportedUnitLabels.ts';
import { AutomaticProductsFormSummary } from '@/shared/forms/AutomaticProductsForm/components/AutomaticProductsFormSummary.tsx';

const ManualPositionProductSelectionSummaryContent = () => {
    const { t } = useTranslation();
    const { contextData } = usePositionContext();
    const { formatNumber } = useFormatters();

    const productConfigurations = contextData.getProductConfigurations();
    const sectionSummaryContentList: SectionSummaryContentItem[] = (productConfigurations ?? []).map(pc => ({
        summaryContentItemId: pc.index,
        label: pc.productName,
        value: `${formatNumber(pc.quantity)} ${t(SUPPORTED_UNIT_LABEL[pc.unit])}`,
    }));

    return <SectionSummaryContent sectionSummaryContentList={sectionSummaryContentList} />;
};

const AutomaticPositionProductSelectionSummaryContent = () => {
    const { contextData } = usePositionContext();

    const formData = contextData.getFormData();
    const businessCase = contextData.getBusinessCase();
    const productConfigurations = contextData.getProductConfigurations();

    if (!businessCase || !formData.productName || !productConfigurations) {
        return;
    }

    return (
        <AutomaticProductsFormSummary
            productName={formData.productName}
            businessCase={businessCase}
            productConfigurations={productConfigurations}
        />
    );
};

export function PositionProductSelectionSummary() {
    const { processingType } = usePositionContext();

    return processingType === 'AUTOMATIC' ? (
        <AutomaticPositionProductSelectionSummaryContent />
    ) : (
        <ManualPositionProductSelectionSummaryContent />
    );
}
